/**
 * @generated SignedSource<<bb45e6ea45d855c6f2af867c9eeeb926>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavItem_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItemBadge_seller">;
  readonly " $fragmentType": "NavItem_seller";
};
export type NavItem_seller$key = {
  readonly " $data"?: NavItem_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavItem_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavItem_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItemBadge_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "06bc7d4c2bce1fe832b99b9186a3158e";

export default node;
